import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { financing, membership } from '../data/content';
import { practice } from '../data/site';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function FinancingSection() {
  return <section id="financing" className="scroll-mt-24 bg-white py-24 lg:py-40" data-id="element-212" data-mp="2vksih4x06lz5">
      <div className="mx-auto grid max-w-shell gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:px-12" data-id="element-213" data-mp="2vmvce01a0z95">
        <Reveal className="lg:col-span-6" data-id="element-214" data-mp="3nbor1tc164gm">
          <SectionLabel data-id="element-215" data-mp="3ncq7yefq9l69">Financing and payments</SectionLabel>
          <h2 className="font-display mt-6 text-[clamp(2rem,4.2vw,3.3rem)] leading-[1.06] text-ink" data-id="element-216" data-mp="3ikqaqtr1l6dd">
            The care you need.
            <br data-id="element-217" data-mp="3eibtge30ueo7" />
            Options that fit you.
          </h2>
          <p className="mt-7 max-w-[52ch] text-[16.5px] leading-[1.85] text-ink/70" data-id="element-218" data-mp="evmytpxbbtpy">
            Ask about the financing and payment options available to help you move forward with
            the treatment you need.
          </p>

          <ul className="mt-10 space-y-5 border-t border-ink/10 pt-8" data-id="element-219" data-mp="2vf34l0fcrthx">
            {financing.points.map(point => <li key={point} className="flex items-start gap-3.5" data-id="element-220" data-mp="30clg8ykr8mtm">
                <CheckIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-accent" strokeWidth={2.25} data-id="element-221" data-mp="2lp0b6z4bkdj2" />
                <span className="text-[16px] leading-[1.7] text-ink/80" data-id="element-222" data-mp="2cn0uk7x7vbgn">{point}</span>
              </li>)}
          </ul>

          <p className="eyebrow mt-12 text-ink/45" data-id="element-223" data-mp="2hneqirljmuyb">Financing providers</p>
          <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-224" data-mp="22q5wtr8rpf3f">
            {financing.providers.map(provider => <li key={provider.name} className="rounded-[12px] border border-ink/[0.09] bg-paper-off/60 p-6" data-id="element-225" data-mp="27pigk34ce61s">
                <h3 className="text-[17px] font-semibold text-ink" data-id="element-226" data-mp="5x41dbt6nfp2">{provider.name}</h3>
                <p className="mt-2.5 text-[15px] leading-relaxed text-ink/65" data-id="element-227" data-mp="5uqbdhdd0tod">
                  {provider.description}
                </p>
              </li>)}
          </ul>
          <p className="mt-5 text-[13px] leading-relaxed text-ink/45" data-id="element-228" data-mp="3vob6iz19i7ge">
            Approval, amounts and terms are confirmed directly with our team.
          </p>
        </Reveal>

        <Reveal delay={0.08} className="lg:col-span-6" data-id="element-229" data-mp="3mn4mwh3bggix">
          <div className="glass-dark relative overflow-hidden rounded-[14px] p-8 text-white lg:sticky lg:top-28 lg:p-10" data-id="element-230" data-mp="n657o5x9gjlr">
            <svg aria-hidden="true" viewBox="0 0 400 400" className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 opacity-40" data-id="element-231" data-mp="i8d6smen1n5f">
              <circle cx="200" cy="200" r="150" fill="none" stroke="#e3262e" strokeWidth="0.6" data-id="element-232" data-mp="9ftd80d7e8rg" />
              <line x1="20" y1="380" x2="380" y2="20" stroke="#e3262e" strokeWidth="0.6" data-id="element-233" data-mp="1154x3fsll2iz" />
            </svg>

            <div className="relative" data-id="element-234" data-mp="2ju94i0nw69ko">
              <p className="eyebrow flex items-center gap-3 text-accent" data-id="element-235" data-mp="2jvafy68tky2x">
                <span aria-hidden="true" className="h-px w-8 bg-accent" data-id="element-236" data-mp="2osanymp8cawo" />
                {membership.name}
              </p>

              <h3 className="font-display mt-6 text-[clamp(1.6rem,2.8vw,2.2rem)] leading-[1.12]" data-id="element-237" data-mp="2xspcduxhq64e">
                {membership.hook}
              </h3>

              <p className="mt-8 flex items-baseline gap-2" data-id="element-238" data-mp="32r0o6b7ciqp9">
                <span className="font-display text-[clamp(3rem,6vw,4.5rem)] leading-none" data-id="element-239" data-mp="37qn10jj9i4xj">
                  {membership.price}
                </span>
                <span className="text-[16px] text-white/55" data-id="element-240" data-mp="3ci4ygxm2tndr">{membership.period}</span>
              </p>

              <ul className="mt-8 space-y-3.5 border-t border-white/10 pt-7" data-id="element-241" data-mp="3gif4ga9vcdsm">
                {membership.includes.map(item => <li key={item} className="flex items-center gap-3" data-id="element-242" data-mp="3qhe7ndbv7h88">
                    <CheckIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-accent" strokeWidth={2.25} data-id="element-243" data-mp="3qfa2yt656e6w" />
                    <span className="text-[16px] text-white/85" data-id="element-244" data-mp="37thz6icq3mno">{item} included</span>
                  </li>)}
              </ul>

              <p className="mt-7 max-w-[44ch] text-[15.5px] leading-relaxed text-white/65" data-id="element-245" data-mp="3hkuhai8pyygi">
                {membership.body}
              </p>

              <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="group mt-9 inline-flex min-h-[52px] items-center gap-2.5 rounded-[10px] bg-white px-6 text-[14.5px] font-medium text-ink transition-all duration-300 hover:shadow-[0_0_0_3px_rgba(255,255,255,0.15)]" data-id="element-246" data-mp="2tw1sd5qilqve">
                Learn about Lima VIP Membership
                <span className="hover-arrow" data-id="element-247" data-mp="j5ussvus12of">
                  <ArrowRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-248" data-mp="e5gkrdt6dsqe" />
                </span>
              </a>

              <p className="mt-5 text-[13.5px] leading-relaxed text-white/50" data-id="element-249" data-mp="lmv8fqil5vab">
                Or call{' '}
                <a href={practice.phoneHref} className="font-medium text-white underline underline-offset-4" data-id="element-250" data-mp="ql6ia18vs5sj">
                  {practice.phone}
                </a>{' '}
                and our team will walk you through it.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}